"use client";
import React from 'react';
import { motion } from 'framer-motion';

const tools = [
    { name: "Adobe Photoshop", logo: "/logos/photoshop.svg" },
    { name: "Figma", logo: "/logos/figma.svg" },
    { name: "WordPress", logo: "/logos/wordpress.svg" },
    { name: "Visual Studio Code", logo: "/logos/vscode.svg" },
    { name: "Google Analytics", logo: "/logos/analytics.svg" },
    { name: "Google Search Console", logo: "/logos/search-console.svg" },
    { name: "SEMrush", logo: "/logos/semrush.svg" },
    { name: "Google Ads", logo: "/logos/google-ads.svg" },
    { name: "Meta Ads Manager", logo: "/logos/meta.svg" },
    { name: "HubSpot", logo: "/logos/hubspot.svg" }
];

// Double the tools for infinite scroll effect
const allTools = [...tools, ...tools];

export default function ToolsCarousel() {
    return (
        <section className="w-full bg-[#090d1e] py-16 overflow-hidden border-t border-b border-white/5" data-theme="dark">
            <div className="container mx-auto px-6 md:px-24 flex flex-col md:flex-row items-center gap-6 md:gap-12">

                {/* Left Side: Content */}
                <div className="w-full md:w-1/4 flex flex-col items-center md:items-start gap-1 md:gap-2 z-10 bg-[#090d1e] md:pr-8 text-center md:text-left">
                    <h3 className="text-white text-xl md:text-2xl font-bold tracking-tight" style={{ fontFamily: "var(--font-clash), 'Clash Display', sans-serif" }}>Everyday&apos;s Toolbox</h3>
                    <p className="text-gray-500 text-sm md:text-base" style={{ fontFamily: "var(--font-manrope, Manrope, sans-serif)" }}>Mastered for every project.</p>
                </div>

                {/* Right Side: Scrolling Carousel */}
                <div className="w-full md:w-3/4 relative">
                    {/* Gradient Fade Overlays */}
                    <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-[#090d1e] to-transparent z-10 pointer-events-none" />
                    <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-[#090d1e] to-transparent z-10 pointer-events-none" />

                    <div className="flex overflow-hidden group">
                        <motion.div
                            className="flex gap-4 md:gap-6 py-4"
                            animate={{ x: [0, -1600] }} // Adjust based on tool count and width
                            transition={{
                                x: {
                                    repeat: Infinity,
                                    repeatType: "loop",
                                    duration: 30, // Faster/Slower scroll
                                    ease: "linear",
                                },
                            }}
                            style={{ width: "max-content" }}
                        >
                            {allTools.map((tool, i) => (
                                <div
                                    key={i}
                                    className="flex items-center justify-center bg-[#151515] hover:bg-[#1a1a1a] border border-white/5 rounded-2xl w-20 h-20 md:w-24 md:h-24 p-5 transition-all duration-300 group/item hover:scale-105 hover:border-blue-500/30 shadow-lg"
                                    title={tool.name}
                                >
                                    <img
                                        src={tool.logo}
                                        alt={tool.name}
                                        className="w-full h-full object-contain filter group-hover/item:scale-110 transition-all duration-500"
                                    />
                                </div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
}
